import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getContent } from "../../api/content";
import { getCourseData, getCourseCategory } from "../../api/course";
import CourseCard from "../../components/courseCard/courseCard";
import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';
import { useGlobalContext } from "../../context/globalContext";
import './courseList.css';

const CourseList = (props) => {
    const { type } = props;
    const [loadingData, setLoadingData] = useState(true);
    const [content, setContent] = useState([]);
    const [courses, setCourses] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(1);
    const [categories, setCategories] = useState([]);
    const location = useLocation();
    const { setActiveMenu, setErrorMessage, setShowErrorMessage } = useGlobalContext();

    // const categories = ['All Courses', 'School Preparation (CBSE-Aligned)', 'Board Exam Courses', 'Competitive Exams'];

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [contentData, courseData, categoryData] = await Promise.all([
                    getContent('course_detail_page_content'),
                    getCourseData('all'),
                    getCourseCategory()
                ]);

                if (contentData.status && courseData.status && categoryData.status) {
                    setContent(contentData.data[0]['content']);
                    setCourses(courseData.data);
                    setCategories(categoryData.data);
                    setLoadingData(false);
                } else {
                    console.log("Error: One or both fetch requests failed.");
                }
            } catch (error) {
                console.log("Error fetching data:", error);
            }
        };

        fetchData();
    }, []);

    setActiveMenu("all-courses");

    // Filter courses by selected category
    const filteredCourses = courses.filter(
      (course) => selectedCategory === 1 || course.category_id === selectedCategory
    );

    return (
        loadingData ? (
            <div className="d-flex justify-content-center">
                <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        ) : (
            <>
                {/* <div className="detail-top-container">
                    <div className="row">
                        <div className="col-6 text-left d-flex flex-column justify-content-center">
                            <span className="head-text text-grey h1 m-10">
                                {content['top_banner']['title']}
                            </span>
                            <br />
                            <div className="head-description text-darkGrey h6">
                                {content['top_banner']['subText']}
                            </div>
                        </div>
                        <div className="col-6 course-top-banner-image-container"></div>
                    </div>
                </div> */}
                <div className="detail-top-container">
                    <div className="row">
                        <div className="col-6 text-left d-flex flex-column justify-content-center">
                        <span className="head-text h1 m-10 text-grey">
                            {content['top_banner']['title']}<br/>
                        </span>
                        <div className="head-description text-darkGrey h6">
                            {content['top_banner']['subText']}
                        </div>
                        </div>
                        {/* <div className="col-1"></div> */}
                        <div className="col-6 course-top-banner-image-container"></div>
                    </div>
                </div>

                <div className="course-container-home container my-5">
                    <div className="row mb-5">
                        <span className="head-text text-grey text-center h1 m-10">
                            Choose Your Path to 
                        </span>
                        <span className="text-center text-secondary-main h2">Academic Success</span>
                    </div>

                    {/* Category Toggle Buttons */}
                    <div className="row mb-4">
                      <div className=" flex-wrap gap-3">
                        {categories.map((category, index) => (
                          <button
                            key={index}
                            type="button"
                            className={`btn ${selectedCategory === category.id ? 'primary-button text-white' : 'primary-not-active-button'} rounded-4 mx-2`}
                            onClick={() => setSelectedCategory(category.id)}
                            style={{ minWidth: "140px", fontWeight: "600" }}
                          >
                            {category.name}
                          </button>
                        ))}
                      </div>
                    </div>

                    {/* Courses Grid */}
                    <div className="row row-cols-1 row-cols-md-3 gy-5">
                        <CourseCard data={filteredCourses} />
                    </div>
                </div>
            </>
        )
    );
};

export default CourseList;
